import { Tabs } from "flowbite-react";

import { useRef, useState } from "react";
import { HiSearch } from "react-icons/hi";
import PageContainer from "../components/PageContainer";
import NewsCalendar from "../sections/calendar/NewsCalendar";
import NewsLists from "../sections/calendar/NewsLists";

const Calendar = () => {
  const tabsRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);

  const disaplayHeader = (
    <div>
      {/* Search Bar */}
      <div className="flex items-center space-x-2 mb-4">
        <div className="relative w-full">
          <HiSearch className="absolute left-3 top-3 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="ค้นหา"
            className="pl-10 pr-4 py-2 w-full border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none"
          />
        </div>
        <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition text-nowrap">
          ค้นหากิจกรรม
        </button>
      </div>{" "}
      <Tabs
        variant="underline"
        ref={tabsRef}
        onActiveTabChange={(tab) => setActiveTab(tab)}
      >
        <Tabs.Item title="List">
          <NewsLists />
        </Tabs.Item>
        <Tabs.Item title="Month">
          <NewsCalendar />
        </Tabs.Item>
      </Tabs>
    </div>
  );

  return (
    <PageContainer title="ข่าวประชาสัมพันธ์และกิจกรรม">
      <section>
        <div className="container  max-w-[1200px] mx-auto  mt-[-50px]">
          <div className="card bg-white shadow-xl mx-auto">
            <div className="card-body">
              {disaplayHeader}
              {/* <NewsLists /> */}
              {/* <NewsCalendar /> */}
            </div>
          </div>
        </div>
      </section>
    </PageContainer>
  );
};

export default Calendar;
